import { render, staticRenderFns } from "./RelocateDialog.vue?vue&type=template&id=12830f87&scoped=true"
import script from "./RelocateDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelocateDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RelocateDialog.vue?vue&type=style&index=0&id=12830f87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12830f87",
  null
  
)

export default component.exports